<template>
	<div class="ims-sales">
		<border-view title="终端统计">
			<div class="view-search" style="padding-top: 24px;">
				<FromComm :FromArr="FromArr" />
				<CommonBtngroup class="btngroup" :qhide="false" @select="handSearch" @reset="handReset" />
			</div>
			<div class="view-switch-list">
				<div class="view-switch">
					<div class="switch-item-blue" v-for="(item,index) in switchItems" :key="index"
						:class="[sjIndex===index?'current-blue':'']" @click="handSjChange(index)">
						{{item}}
					</div>
				</div>
			</div>
			<!-- 图表 -->
			<div class="view-row">
				<!--:key="sjIndex"-->
				<term-map ref="termap" :type="sjIndex" @select="handSelected" @change="(e)=>mapData = e" />
				<info-table v-if="query.Name" :title="`${query.Name||''}${switchItems[sjIndex]}家数`" :titles="headerData"
					:datas="hospInfo&&hospInfo.data" />
				<term-table v-else :datas="mapData" :type="sjIndex" />
			</div>
			<div class="view-row" style="flex-direction: column;margin-top: 24px;" v-if="dataInfo">
				<div class="view-search" style="padding-top: 24px;min-height:210px;">
					<FromComm :FromArr="FromArr3" @selectChange="selectChange3" @remoteMethod="remoteMethod" />
					<CommonBtngroup class="btngroup" style="min-width:180px;" :qhide="false" @select="handSearch('3')"
						@reset="handReset('3')" />
				</div>
				<div class="view-switch-list">
					<div class="view-switch" style="margin-right:48px;">
						<div class="switch-item-red" v-for="(item,index) in switchYeItems" :key="index"
							:class="[l3Index===index?'current-red':'']" @click="switchChange(index,'l3')">
							{{item}}
						</div>
					</div>
				</div>
				<company-number :info="dataInfo" :type="l3Index" />
			</div>
		</border-view>
	</div>
</template>

<script>
	import {
		GetHelperLevel1,
		GetHelperLevel3,
		GetLEVEL3HospitalCount,
		GetZyloxHospitalCountByTendency,
		GetHelperAreaMan,
		GetHelperRegionMan,
		GetHelperSalesMan,
		GetProvinceSalesAmount,
		GetHospitalList,
		GetCustomerList
	} from '@/api/newsapi'
	import termMap from './charts/term-map.vue';
	import termTable from './charts/term-table.vue';
	import companyNumber from './charts/company-number.vue';
	import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import borderView from './border-view.vue';
	import infoTable from './charts/info-table.vue';
	import {
		FromArr,
	} from '../FormData/termStatis';
	import {
		FromArr3
	} from '../FormData/imsSales';
	import utils from '../../../../common/utils.js';
	export default {
		components: {
			termMap,
			termTable,
			companyNumber,
			FromComm,
			CommonBtngroup,
			borderView,
			infoTable
		},
		data() {
			return {
				FromArr: [],
				sjIndex: 0, //数量金额
				switchItems: ['植入', '授权'],
				l3Index: 1,
				switchYeItems: ['月度', '季度', '年度'],
				query: {},
				mapData: [],
				hospInfo: null,
				headerData: [{
					"label": 'LEVEL3',
					"key": 'LEVEL3',
					"width": "flex"
				}, {
					"label": '植入家数',
					"key": 'IMSCount',
					"width": "flex"
				}, {
					"label": '授权家数',
					"key": 'AuthorityCount',
					"width": "flex"
				}],
				dataInfo: null,
				FromArr3: [],
				query3: {},
			}
		},
		created() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArr3 = JSON.parse(JSON.stringify(FromArr3))
			this.getHelperLevel1();
			this.getHelperLevel3();
			this.getL3HospitalCount();
			this.getProvinceSalesAmount();
			this.getZyloxHospitalCountByTendency();
		},
		methods: {
			handSjChange(i) {
				this.sjIndex = i;
				this.mapData = [];
				this.query.sjIndex = i;
				this.$refs.termap.init(this.query);
			},
			//获取l1数据
			async getHelperLevel1() {
				let {
					code,
					data
				} = await GetHelperLevel1({})
				if (code == 0) {
					this.FromArr[0].options = [{
						key: '不限',
						value: '',
					}]
					this.FromArr3[0].options = [{
						key: '不限',
						value: '',
					}]
					data.map((item, index) => {
						this.FromArr[0].options.push({
							key: item.value,
							value: item.key
						});
						this.FromArr3[0].options.push({
							key: item.value,
							value: item.key
						});
					})
				}
			}, //获取l3数据
			async getHelperLevel3(l1 = '') {
				let params = {};
				if (l1) {
					params.LEVEL1 = l1;
				}
				let {
					code,
					data
				} = await GetHelperLevel3(params);

				if (code == 0) {
					if (!l1) {
						this.FromArr[2].options = [];
					}
					this.FromArr3[1].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.value,
							value: item.key
						}
						if (!l1) {
							this.FromArr[2].options.push(obj);
						}
						this.FromArr3[1].options.push(obj);
					})
				}
			},
			//获取医院top20
			async getL3HospitalCount(e = "") {
				if (e) {
					this.query.ProvinceID = e.id;
					this.query.Name = e.name;
				} else {
					delete this.query.ProvinceID;
					delete this.query.Name;
				}
				this.$forceUpdate();
				let {
					code,
					data
				} = await GetLEVEL3HospitalCount(this.query);

				if (code == 0) {
					if (data && data.data.length) {
						data.data.push({
							LEVEL3: '合计：',
							IMSCount: data.TotalIMS,
							AuthorityCount: data.TotalAuthority
						})
					}
					this.hospInfo = data;
				}
			},
			//获取大区经理
			async getHelperAreaMan(l1 = '') {
				let params = {};
				if (l1) {
					params.LEVEL1 = l1;
				}
				let {
					code,
					data
				} = await GetHelperAreaMan(params);

				if (code == 0) {
					this.FromArr3[2].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						this.FromArr3[2].options.push(obj);
					})
				}
			},
			//三级销售（地区）
			async getHelperRegionMan(str, l1) {
				let {
					code,
					data
				} = await GetHelperRegionMan({
					ParentUserName: str,
					LEVEL1: l1
				});

				if (code == 0) {
					this.FromArr3[3].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						this.FromArr3[3].options.push(obj);
					})
				}
			},
			//销售代表
			async getHelperSalesMan(str, l1) {
				let {
					code,
					data
				} = await GetHelperSalesMan({
					ParentUserName: str,
					LEVEL1: l1
				});

				if (code == 0) {
					this.FromArr3[4].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						this.FromArr3[4].options.push(obj);
					})
				}
			},
			//省份
			async getProvinceSalesAmount() {
				let {
					code,
					data
				} = await GetProvinceSalesAmount({});

				if (code == 0) {
					this.FromArr3[5].options = [{
						key: '不限',
						value: ''
					}];
					data.data.map((item, index) => {
						let obj = {
							key: item.Name,
							value: item.Name
						}
						this.FromArr3[5].options.push(obj);
					})
				}
			},
			switchChange(e, k) {
				this[k + 'Index'] = e;
				this.getZyloxHospitalCountByTendency();
			},
			//FromArr3 下拉框触发事件
			selectChange3(e) {
				console.log(e);
				switch (e) {
					case 0:
						this.getHelperLevel3(this.FromArr3[0].modelvalue === '不限' ? '' : this.FromArr3[0].modelvalue);
						this.getHelperAreaMan(this.FromArr3[0].modelvalue === '不限' ? '' : this.FromArr3[0].modelvalue)
						this.getHelperRegionMan(this.FromArr3[2].modelvalue.join(','), this.FromArr3[0].modelvalue ===
							'不限' ? '' : this.FromArr3[0].modelvalue);
						this.getHelperSalesMan(this.FromArr3[2].modelvalue.join(','), this.FromArr3[0].modelvalue ===
							'不限' ? '' : this.FromArr3[0].modelvalue);
						break;
					case 1:
						break;
					case 2:
						this.getHelperRegionMan(this.FromArr3[2].modelvalue.join(','));
						break;
					case 3:
						this.getHelperSalesMan(this.FromArr3[3].modelvalue.join(','));
						break;
					case 4:
						break;
				}
			},
			//医院列表
			async getHospitalList(hpName = '') {
				let {
					code,
					data
				} = await GetHospitalList({
					HPName: hpName,
					pageIndex: 1,
					pageSize: 9999,
					IsTerminalHPOnly: 1
				})
				if (code == 0) {
					this.FromArr3[6].options = []
					data.data.map((item, index) => {
						let obj = {
							label: item.HPName,
							value: item.HPID
						}
						this.FromArr3[6].options.push(obj)
					})
				}
			},
			//经销商列表
			async getCustomerList(CusName = '') {
				let {
					code,
					data
				} = await GetCustomerList({
					CusName: CusName,
					pageIndex: 1,
					pageSize: 9999
				})
				if (code == 0) {
					this.FromArr3[7].options = []
					data.data.map((item, index) => {
						let obj = {
							label: item.CusName,
							value: item.CusCode
						}
						this.FromArr3[7].options.push(obj)
					})
				}
			},
			remoteMethod(param) {
				if (param.parsign === "hospitalMethod") {
					this.getHospitalList(param.qurey);
				}

				if (param.parsign === "customMethod") {
					this.getCustomerList(param.qurey);
				}
			},
			async getZyloxHospitalCountByTendency(e = {}) {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let params = {};
				params.ByQuarter = this.l3Index;
				params = Object.assign({}, params, e, this.query3);
				let {
					code,
					data
				} = await GetZyloxHospitalCountByTendency(params);
				loading.close();
				if (code == 0 && data) {
					this.dataInfo = data.tendencyReport;
				}
			},
			handReset(e = '') {
				if (e == '3') {
					this.FromArr3.map((item, index) => {
						item.modelvalue = '';
					})
					this.query3 = {};
					this.getZyloxHospitalCountByTendency();
				} else {
					this.FromArr.map((item, index) => {
						item.modelvalue = '';
						item.StartTime = '';
						item.EndTime = '';
					})
					this.query = {};
					this.$refs.termap.init(this.query);
					this.getL3HospitalCount();
				}
			},
			handSearch(e = '') {
				if (e == '3') {
					this.query3.LEVEL1 = this.FromArr3[0].modelvalue;
					this.query3.LEVEL3 = this.FromArr3[1].modelvalue ? this.FromArr3[1].modelvalue.join(',') : '';
					this.query3.AreaMan = this.FromArr3[2].modelvalue ? this.FromArr3[2].modelvalue.join(',') : '';
					this.query3.RegionMan = this.FromArr3[3].modelvalue ? this.FromArr3[3].modelvalue.join(',') : '';
					this.query3.SalesMan = this.FromArr3[4].modelvalue ? this.FromArr3[4].modelvalue.join(',') : '';
					this.query3.ProvinceName = this.FromArr3[5].modelvalue;
					this.query3.HPID = this.FromArr3[6].modelvalue ? this.FromArr3[6].modelvalue.join(',') : '';
					this.query3.TerminalHPID = this.FromArr3[6].modelvalue ? this.FromArr3[6].modelvalue.join(',') : '';
					this.query3.CusCode = this.FromArr3[7].modelvalue ? this.FromArr3[7].modelvalue.join(',') : '';
					this.getZyloxHospitalCountByTendency();
				} else {
					if (this.FromArr[0].modelvalue) {
						this.query.LEVEL1 = this.FromArr[0].modelvalue;
					} else {
						delete this.query.LEVEL1;
					}
					if (this.FromArr[1].modelvalue) {
						this.query.Year = this.FromArr[1].modelvalue;
					} else {
						delete this.query.Year;
					}
					if (this.FromArr[2].modelvalue && this.FromArr[2].modelvalue.length) {
						this.query.LEVEL3 = this.FromArr[2].modelvalue.join(',');
					} else {
						delete this.query.LEVEL3;
					}
					if (this.FromArr[3].modelvalue && this.FromArr[3].modelvalue.length) {
						this.query.startDate = this.FromArr[3].modelvalue[0];
						this.query.endDate = this.FromArr[3].modelvalue[1];
					} else {
						delete this.query.startDate;
						delete this.query.endDate;
					}
					this.$refs.termap.init(this.query);
					this.getL3HospitalCount()
				}
			},
			handSelected: utils.debounce(function(e) {
				this.getL3HospitalCount(e);
			}, 300)
		}
	}
</script>

<style lang="less" scoped>
	.ims-sales {
		padding-bottom: 200px;

		.view-row {
			display: flex;
		}

		.view-search {
			height: 88px;
			margin: 16px 0px 16px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #E5E5E5;

			.btngroup {
				float: none;
				//margin-left: 24px;
				margin-top: 0px;
			}
		}

		.view-switch-list {
			display: flex;
			align-items: center;
			justify-content: center;

			.view-switch {
				overflow: hidden;
				display: flex;
				cursor: pointer;

				.switch-item-red {
					width: 80px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					box-sizing: border-box;
					font-size: 14px;
					font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
					font-weight: 400;
					color: #E71D43;
					background: url('../../../../assets/report/btn-red.png') no-repeat;
					background-size: 100% 100%;
					margin: 0px 8px;
				}

				.switch-item-blue {
					width: 80px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					box-sizing: border-box;
					font-size: 14px;
					font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
					font-weight: 400;
					color: #00266D;
					background: url('../../../../assets/report/btn-blue.png') no-repeat;
					background-size: 100% 100%;
					margin: 0px 8px;
				}

				.current-red {
					background: url('../../../../assets/report/btn-red-checked.png') no-repeat;
					background-size: 100% 100%;
					color: #FFFFFF;
				}

				.current-blue {
					background: url('../../../../assets/report/btn-blue-checked.png') no-repeat;
					background-size: 100% 100%;
					color: #FFFFFF;
				}
			}
		}
	}
</style>